import React from 'react';
import { Helmet } from 'react-helmet-async';
import { gtmNoScript, gtmScript } from './gtm';
import { onetrustScript, onetrustScriptOptanon } from './onetrust';

const Analytics: React.FC = () => (
  <>
    <Helmet>
      <script
        src="https://cdn.optimizely.com/js/22421750808.js"
        type="text/plain"
        className="optanon-category-C0002-C0004"
        async
        defer
      />
      {gtmScript}
      {onetrustScript}
      {onetrustScriptOptanon}
    </Helmet>
    {gtmNoScript}
  </>
);

export default Analytics;
